import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ScrollThroughBlock {
  constructor() {
    if (window.matchMedia('(min-width: 1440px)').matches) {
      this.fontSizes = ['72px', '56px', '42px'];
    } else if (window.matchMedia('(min-width: 1200px)').matches) {
      this.fontSizes = ['64px', '48px', '42px'];
    } else if (window.matchMedia('(min-width: 900px)').matches) {
      this.fontSizes = ['48px', '42px', '32px'];
    } else if (window.matchMedia('(min-width: 760px)').matches) {
      this.fontSizes = ['42px', '36px', '28px'];
    } else if (window.matchMedia('(min-width: 320px)').matches) {
      this.fontSizes = ['36px', '28px', '24px'];
    }

    this.init();
  }

  init() {
    const triggerElementSelector = '.js-product-benefits-expressive-wrapper';
    const triggerElement = document.querySelector(triggerElementSelector);
    if (!triggerElement) {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: triggerElementSelector,
        start: 'top 33%',
        end: 'bottom top',
        pin: true,
        scrub: true,
        //markers: true,
      },
    });

    let items = gsap.utils.toArray('.js-product-benefits-expressive-item');

    timeline.to(items[0], { fontSize: this.fontSizes[0] }, '<').to(items[1], { fontSize: this.fontSizes[1] }, '<');

    items.forEach((item, index) => {
      if (index > 0) {
        timeline.to(item, { duration: 0.3, fontSize: this.fontSizes[0] });
        timeline.to(
          items[index - 1],
          {
            duration: 0.3,
            fontSize: this.fontSizes[2],
          },
          '<',
        );
      }
      if (index < items.length) {
        timeline.to(
          items[index + 1],
          {
            duration: 0.3,
            fontSize: this.fontSizes[1],
          },
          '<',
        );
      }
    });
  }
}
